import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminSocialMedia = lazy(() => import("@/pages/admin/AdminSocialMedia"));

export const Route = createFileRoute("/admin/social-media")({
  component: AdminSocialMedia,
});
